import React, { useState } from "react";
import { useLanguage } from "../../contexts/LanguageContext";
import { Link } from "react-router-dom";
const RoleCard = () => {
const [showModal, setShowModal] = useState(false);
  const { t } = useLanguage();

  return (
    <div className="role-selection-container" style={{
      minHeight: "70vh",
      background: "linear-gradient(135deg, #f5f7fa 0%, #e4e8f0 100%)",
      padding: "4rem 0",
      position: "relative",
      overflow: "hidden"
    }}>
      {/* Decorative elements */}
      <div style={{
        position: "absolute",
        top: "-50px",
        right: "-50px",
        width: "300px",
        height: "300px",
        borderRadius: "50%",
        background: "radial-gradient(circle, rgba(0,123,255,0.1) 0%, rgba(0,123,255,0) 70%)",
        zIndex: 0
      }}></div>
      <div style={{
        position: "absolute",
        bottom: "-100px",
        left: "-100px",
        width: "400px",
        height: "400px",
        borderRadius: "50%",
        background: "radial-gradient(circle, rgba(40,167,69,0.1) 0%, rgba(40,167,69,0) 70%)",
        zIndex: 0
      }}></div>

      <div className="container" style={{ position: "relative", zIndex: 1 }}>
        <div className="text-center mb-5">
          <h2 className="display-5 fw-bold mb-3" style={{
  color: "var(--primary)",
  // background: "linear-gradient(to right, #2c3e50, #4ca1af)",
  // WebkitBackgroundClip: "text",
  // WebkitTextFillColor: "transparent",
  fontWeight: 800
}}>
            {t('role.chooseYourRole', 'Choose Your Role')}
          </h2>
          <p className="lead text-muted" style={{ 
            maxWidth: "600px",
            margin: "0 auto",
            fontSize: "1.1rem"
          }}>
            {t('role.selectRoleDescription', 'Select the role that best describes you to get started.')}
          </p>
        </div>

        <div className="row justify-content-center g-4">
          {/* Buyer Card */}
          <div className="col-md-4">
            <Link 
              to="/buyer-dashboard" 
              className="role-card d-block text-decoration-none h-100"
              style={{
                background: "white",
                borderRadius: "16px",
                padding: "2rem",
                boxShadow: "0 10px 30px rgba(0, 0, 0, 0.08)",
                transition: "all 0.3s ease",
                border: "1px solid rgba(0, 0, 0, 0.05)",
                textAlign: "center",
                position: "relative",
                overflow: "hidden",
                zIndex: 1
              }}
              onMouseOver={(e) => {
                e.currentTarget.style.transform = "translateY(-5px)";
                e.currentTarget.style.boxShadow = "0 15px 35px rgba(0, 123, 255, 0.15)";
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "0 10px 30px rgba(0, 0, 0, 0.08)";
              }}
            >
              <div 
                className="role-icon mx-auto mb-4"
                style={{
                  width: "100px",
                  height: "100px",
                  borderRadius: "50%",
                  background: "linear-gradient(135deg, #007bff 0%, #00b4ff 100%)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "white",
                  fontSize: "2.5rem",
                  transition: "all 0.3s ease"
                }}
              >
                <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" width="48" height="48">
                  <g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M8 7C9.65685 7 11 5.65685 11 4C11 2.34315 9.65685 1 8 1C6.34315 1 5 2.34315 5 4C5 5.65685 6.34315 7 8 7Z" fill="#ffffff"></path> <path d="M14 12C14 10.3431 12.6569 9 11 9H5C3.34315 9 2 10.3431 2 12V15H14V12Z" fill="#ffffff"></path> </g></svg>
              </div>
              <h4 className="h4 mb-3" style={{ color: "#2c3e50" }}>
                {t('role.buyer', 'Buyer')}
              </h4>
              <p className="text-muted mb-0" style={{ fontSize: "0.95rem" }}>
                {t('role.buyerDescription', 'Purchase quality yarn products')}
              </p>
              <div className="hover-indicator" style={{
                position: "absolute",
                bottom: "0",
                left: "0",
                width: "100%",
                height: "4px",
                background: "linear-gradient(135deg, #007bff 0%, #00b4ff 100%)",
                transform: "scaleX(0)",
                transformOrigin: "left",
                transition: "transform 0.3s ease"
              }}></div>
            </Link>
          </div>

          {/* Seller Card */}
          <div className="col-md-4">
            <Link 
              to="/seller-dashboard" 
              className="role-card d-block text-decoration-none h-100"
              style={{
                background: "white",
                borderRadius: "16px",
                padding: "2rem",
                boxShadow: "0 10px 30px rgba(0, 0, 0, 0.08)",
                transition: "all 0.3s ease",
                border: "1px solid rgba(0, 0, 0, 0.05)",
                textAlign: "center",
                position: "relative",
                overflow: "hidden",
                zIndex: 1
              }}
              onMouseOver={(e) => {
                e.currentTarget.style.transform = "translateY(-5px)";
                e.currentTarget.style.boxShadow = "0 15px 35px rgba(40, 167, 69, 0.15)";
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "0 10px 30px rgba(0, 0, 0, 0.08)";
              }}
            >
              <div 
                className="role-icon mx-auto mb-4"
                style={{
                  width: "100px",
                  height: "100px",
                  borderRadius: "50%",
                  background: "linear-gradient(135deg, #28a745 0%, #5cb85c 100%)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "white",
                  fontSize: "2.5rem",
                  transition: "all 0.3s ease"
                }}
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" fill="currentColor" viewBox="0 0 16 16">
                  <path d="M4 10.781c.148 1.667 1.513 2.85 3.591 3.003V15h1.043v-1.216c2.27-.179 3.678-1.438 3.678-3.3 0-1.59-.947-2.51-2.956-3.028l-.722-.187V3.467c1.122.11 1.879.714 2.07 1.616h1.47c-.166-1.6-1.54-2.748-3.54-2.875V1H7.591v1.233c-1.939.23-3.27 1.472-3.27 3.156 0 1.454.966 2.483 2.661 2.917l.61.162v4.031c-1.149-.17-1.94-.8-2.131-1.718zm3.391-3.836c-1.043-.263-1.6-.825-1.6-1.616 0-.944.704-1.641 1.8-1.828v3.495l-.2-.05zm1.591 1.872c1.287.323 1.852.859 1.852 1.769 0 1.097-.826 1.828-2.2 1.939V8.73z"/>
                </svg>
              </div>
              <h4 className="h4 mb-3" style={{ color: "#2c3e50" }}>
                {t('role.seller', 'Seller')}
              </h4>
              <p className="text-muted mb-0" style={{ fontSize: "0.95rem" }}>
                {t('role.sellerDescription', 'List and sell your yarn products')}
              </p>
              <div className="hover-indicator" style={{
                position: "absolute",
                bottom: "0",
                left: "0",
                width: "100%",
                height: "4px",
                background: "linear-gradient(135deg, #28a745 0%, #5cb85c 100%)",
                transform: "scaleX(0)",
                transformOrigin: "left",
                transition: "transform 0.3s ease"
              }}></div>
            </Link>
          </div>

          {/* Other Card */}
          <div className="col-md-4">
            <Link 
              to="#" 
               onClick={(e) => {
    e.preventDefault();
    setShowModal(true);
  }}
              className="role-card d-block text-decoration-none h-100"
              style={{
                background: "white",
                borderRadius: "16px",
                padding: "2rem",
                boxShadow: "0 10px 30px rgba(0, 0, 0, 0.08)",
                transition: "all 0.3s ease",
                border: "1px solid rgba(0, 0, 0, 0.05)",
                textAlign: "center",
                position: "relative",
                overflow: "hidden",
                zIndex: 1
              }}
              onMouseOver={(e) => {
                e.currentTarget.style.transform = "translateY(-5px)";
                e.currentTarget.style.boxShadow = "0 15px 35px rgba(108, 117, 125, 0.15)";
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "0 10px 30px rgba(0, 0, 0, 0.08)";
              }}
            >
              <div 
                className="role-icon mx-auto mb-4"
                style={{
                  width: "100px",
                  height: "100px",
                  borderRadius: "50%",
                  background: "linear-gradient(135deg, #6c757d 0%, #868e96 100%)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "white",
                  fontSize: "2.5rem",
                  transition: "all 0.3s ease"
                }}
              >
                <i className="fas fa-ellipsis-h"></i>
              </div>
              <h4 className="h4 mb-3" style={{ color: "#2c3e50" }}>
                {t('role.other', 'Other')}
              </h4>
              <p className="text-muted mb-0" style={{ fontSize: "0.95rem" }}>
                {t('role.otherDescription', 'Explore other options')}
              </p>
              <div className="hover-indicator" style={{
                position: "absolute",
                bottom: "0",
                left: "0",
                width: "100%",
                height: "4px",
                background: "linear-gradient(135deg, #6c757d 0%, #868e96 100%)",
                transform: "scaleX(0)",
                transformOrigin: "left",
                transition: "transform 0.3s ease"
              }}></div>
            </Link>
          </div>
        </div>
      </div>

      {showModal && (
  <div
    className="modal fade show"
    style={{
      display: "block",
      backgroundColor: "rgba(0,0,0,0.5)",
      position: "fixed",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      zIndex: 9999,
    }}
    onClick={() => setShowModal(false)}
  >
    <div
      className="modal-dialog modal-dialog-centered"
      onClick={(e) => e.stopPropagation()}
    >
      <div className="modal-content p-4 text-center">
        <h5 className="mb-3">More Features Coming Soon</h5>
        <button className="btn btn-secondary" onClick={() => setShowModal(false)}>
          Close
        </button>
      </div>
    </div>
  </div>
)}

      
    </div>


  );
};

export default RoleCard;